import axios from 'axios'
import { Notification } from 'element-ui';
// 创建axios实例
const service = axios.create({
  baseURL: '', // api 的 base_url
  timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 设置请求头
    // config.headers.post['Content-type'] = 'application/json'
    config.headers['token'] = localStorage.getItem('token') // 让每个请求携带自定义token 请根据实际情况自行修改
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {

    /**
     * code为非200时抛错 可结合自己业务进行修改
     */
    if (response.data.code === 401 || response.data.code === 403) {
      Notification.error({
        title: '错误',
        message: '登录口令已失效'
      })
      setTimeout(function () { window.location.href = _LOGIN_ }, 1500);
    }
    if (response.data.hasOwnProperty('code') && response.data.code !== 200) {
      // error处理
      Notification.error({
        title: '错误',
        message: response.data.data.message ? response.data.data.message : ''
      })
      return response.data
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    if (error.response.status === 401 || error.response.status === 403) {
      Notification.error({
        title: '错误',
        message: '登录口令已失效'
      })
       setTimeout(function () { window.location.href = _LOGIN_ }, 1500);
    }
    return false
  }
)

export default service
